import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
// Initialize Firebase
const firebaseConfig = {
  apiKey: 'AIzaSyCf9623BDkPmzLulNfOc6wtlPzGFvl_7BQ',
  authDomain: 'react-mate.firebaseapp.com',
  databaseURL: 'https://react-mate.firebaseio.com',
  projectId: 'react-mate',
  storageBucket: 'react-mate.appspot.com',
  messagingSenderId: '851503876942',
  appId: '1:851503876942:web:48e3042414b94d9e5e6c1f',
};

firebase.initializeApp(firebaseConfig);

const auth = firebase.auth();

const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
const githubAuthProvider = new firebase.auth.GithubAuthProvider();
const facebookAuthProvider = new firebase.auth.FacebookAuthProvider();
const twitterAuthProvider = new firebase.auth.TwitterAuthProvider();

export {
  auth,
  googleAuthProvider,
  githubAuthProvider,
  facebookAuthProvider,
  twitterAuthProvider,
};
